<template>
    <div class="payment">
        <h2>Dostęp do wydarzenia został przyznany!</h2>
    </div>
</template>
<script>
export default {
    props: [
        "event_id",
        "price",
        "asset_path",
        "profession",
        "profile_url",
        "register_type",
    ],

    data() {
        return {
            paymentMethod: null,
            amount: this.price,
            profession: this.profession,
            code: null,
            discountValue: 0,
            content: null,
            customizableFormData: [],
            formFields: [],
            agreements: [],
            agreementInputs: [],
            errorMessages: [],
            numberOfRequireInputes: 0,
            isDisabled: false,
            type: null,
            customizableFormDisplay: true,
            hotelRooms: [],
            hotelRoom: null,
            eventDates: [],
            companions: [],
            registerType: this.register_type,
        };
    },
    beforeMount() {
        axios
            .post("/api/payment/create", {
                eventableId: this.event_id,
                eventableType: "App\\Models\\Event",
                amount: 0,
                type: "offline",
            })
            .then((response) => {
                let data = response.data.data;
                console.log(data);
                if (data.redirect_panel) {
                    this.$notify({
                        group: "foo",
                        type: "success",
                        title: response.data.message,
                    });

                    setTimeout(function () {
                        window.location.href = "/profil";
                    }, 1500);
                }
                if (data.url) {
                    this.$notify({
                        group: "foo",
                        type: "success",
                        title: response.data.message,
                    });

                    setTimeout(function () {
                        window.location.href = data.url;
                    }, 1500);
                }
                if (data.content) {
                    this.$notify({
                        group: "foo",
                        type: "success",
                        title: response.data.message,
                    });
                    this.content = data.content;
                    this.content +=
                        "</br></br> Kwota do zapłaty: " +
                        data.payment["amount"] +
                        "zł";
                    this.content += "</br> Tytułem: Imię, Nazwisko FIT 2023";
                }
            })
            .catch((error) => {
                this.isDisabled = false;
                var errors = error.response.data.errors;
                Object.values(errors).forEach((singleError) => {
                    this.$notify({
                        group: "foo",
                        type: "error",
                        title: singleError[0],
                    });
                });
            });
    },
    // axios
    //     .get("/api/agreements", {
    //         params: {
    //             eventableId: this.event_id,
    //             eventableType: "App\\Models\\Event",
    //         },
    //     })
    //     .then((response) => {
    //         this.agreementInputs = response.data.data;
    //     });

    // axios
    //     .get("/api/hotel-rooms", {
    //         params: {
    //             eventableId: this.event_id,
    //             eventableType: "App\\Models\\Event",
    //         },
    //     })
    //     .then((response) => {
    //         this.hotelRooms = response.data.data;
    //     });

    // axios
    //     .get("/api/eventables/get-dates", {
    //         params: {
    //             eventableId: this.event_id,
    //             eventableType: "App\\Models\\Event",
    //         },
    //     })
    //     .then((response) => {
    //         this.eventDates = response.data;
    //     });

    // axios
    //     .get("/api/customizable-forms", {
    //         params: {
    //             eventableId: this.event_id,
    //             eventableType: "App\\Models\\Event",
    //         },
    //     })
    //     .then((response) => {
    //         console.log(response);
    //         this.formFields = response.data.data;

    //         var newFormData = [];
    //         this.formFields.fields.forEach(function (item, index) {
    //             newFormData[index] = {
    //                 form_name: item.name,
    //                 with_companion: false,
    //                 companion_allowed:
    //                     item.companion_allowed === "1" ? true : false,
    //                 does_attend: false,
    //                 companion_name: null,
    //             };
    //         });

    //         this.customizableFormData = newFormData;
    //     });

    // this.setPrice();
    methods: {
        checkCompanion(companion, index) {
            if (companion.value == "") {
                this.$set(companion, "status", "ready_to_fill");
            } else {
                axios
                    .post("/api/check-companion", {
                        eventableId: this.event_id,
                        eventableType: "App\\Models\\Event",
                        hotelRoom: this.hotelRoom,
                        companion: companion.value,
                    })
                    .then((response) => {
                        console.log(response.data);
                        this.$set(companion, "status", response.data);
                        let msg = "";
                        if (response.data == "already_filled") {
                            msg =
                                "Wybrany uczestnik jest już zakwaterowany z inną osobą. Prosimy skontaktować się z organizatorem.";
                        } else if (response.data == "not_exist") {
                            msg = "Wybrany uczestnik nie istnieje";
                        } else if (
                            response.data == "registered_to_other_room"
                        ) {
                            msg =
                                "Wybrany uczestnik zapisał się do innego pokoju";
                        }

                        if (msg != "") {
                            this.$notify({
                                group: "foo",
                                type: "error",
                                title: msg,
                            });
                        }
                    })
                    .catch((error) => {
                        var errors = error.response.data.errors;
                        Object.values(errors).forEach((singleError) => {
                            this.$notify({
                                group: "foo",
                                type: "error",
                                title: singleError[0],
                            });
                        });
                    });
            }
        },
        setHotelRoom() {
            this.companions = [];
            for (let i = 0; i < this.hotelRoom.person_limit - 1; i++) {
                this.companions.push({ value: "", hasError: false });
            }
            this.setPrice();
        },
        geNumberOfRequireInputes() {
            for (let i = 0; i < this.agreementInputs.length; i++) {
                if (
                    this.agreementInputs[i].active == 1 &&
                    this.agreementInputs[i].required == 1
                ) {
                    this.numberOfRequireInputes++;
                }
            }
        },

        setFormField(formName, inputName, value) {
            var existIndex = this.customizableFormData.findIndex((obj) => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                var newIndex = this.customizableFormData.length;
                var newArray = {
                    form_name: formName,
                };
                newArray[inputName] = value;
                this.$set(this.customizableFormData, newIndex, newArray);
            } else {
                var newArray = this.customizableFormData[existIndex];
                newArray[inputName] = value;
                this.$set(this.customizableFormData, existIndex, newArray);
            }
        },
        isFieldTrue(formName, inputName) {
            var existIndex = this.customizableFormData.findIndex((obj) => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                return false;
            }

            if (
                this.customizableFormData[existIndex][inputName] &&
                this.customizableFormData[existIndex][inputName] === true
            ) {
                return true;
            }
            return false;
        },
        setAgreement(e) {
            if (this.agreements.includes(e.target.value)) {
                var indexToDrop = this.agreements.indexOf(e.target.value);
                if (indexToDrop !== -1) {
                    this.agreements.splice(indexToDrop, 1);
                }
            } else {
                this.agreements.push(e.target.value);
            }
        },
        setPrice() {
            axios
                .post("/api/prices", {
                    customizableFormData: this.customizableFormData,
                    code: this.code,
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                    type: this.type,
                    eventDates: this.eventDates,
                    hotelRoom: this.hotelRoom,
                })
                .then((response) => {
                    this.amount = response.data.data.price;
                    this.discountValue = response.data.data.discountValue;
                })
                .catch((error) => {
                    this.amount = response.data.data.price;
                    this.discountValue = 0;
                    if (error.response.data.errors.code) {
                        this.$notify({
                            group: "foo",
                            type: "error",
                            title: error.response.data.errors.code[0],
                        });
                    }
                });
        },
        attendanceType(display) {
            this.setPrice();
            this.customizableFormDisplay = display;
            this.eventDates.forEach((eventDate) => {
                eventDate.checked = false;
            });
            this.hotelRoom = null;
        },
        getAssetPath(path) {
            return this.asset_path + path;
        },
    },
};
</script>
